import { ComponentType } from 'react'

type DynamicImportType = () => Promise<{ default: ComponentType<any> }>

type Entrypoints = {
  [x: string]: DynamicImportType
}

export enum AppName {
  EDMQueryForm = 'edmqueryform',
  BioSolidRecyclingForm = 'bio-solids-recycling',
  claimingCompensationForm = 'claiming-compensation-form',
  bereavementForm = 'bereavement-form'
}

export const entrypoints: Entrypoints = {
  [AppName.EDMQueryForm]: () => import('../apps/edmqueryform'),
  [AppName.BioSolidRecyclingForm]: () =>
    import('../apps/bioSolidsRecyclingForm'),
  [AppName.claimingCompensationForm]: () =>
    import('../apps/claimingCompensationForm'),
  [AppName.bereavementForm]: () =>
    import('../apps/bereavementForm/routes')
}

export const entrypointConfig = {
  [AppName.EDMQueryForm]: {
    analyticsKey: 'simple-forms.edm-query'
  },
  [AppName.BioSolidRecyclingForm]: {
    analyticsKey: 'simple-forms.bio-solids-recycling'
  },
  [AppName.claimingCompensationForm]: {
    analyticsKey: 'account-management.cgs-payment'
  },
  [AppName.bereavementForm]: {
    analyticsKey: 'simple-forms.bereavement-form'
  }
}
